<div class="verification-container">
  <div class="verification-box">
    <div class="logo-container">
        <img [src]="logoPath" alt="Nevada Department of Education Logo" class="logo-header">
    </div>
    
    <div class="divider-horizontal"></div>
    
    <div class="content-area">
      <div class="header-section">
        <h1 class="title">
          {{ mode === '2fa' ? 'Enter your verification code' : 'Verify Your Identity' }}
        </h1>
        <p class="description" *ngIf="mode === '2fa'">
          Enter the 6-digit verification code sent to your
          <span *ngIf="method === 'email'">email</span>
          <span *ngIf="method === 'phone'">phone number</span>.
        </p>
        <p class="description" *ngIf="mode !== '2fa'">
          Enter Your Verification Code.
        </p>
      </div>
      
      <div class="otp-section">
        <div class="otp-label">
          <ng-container *ngIf="mode === '2fa'; else defaultLabel">
          <span>One-Time Password</span>
          <span class="required" >*</span>
          </ng-container>
          <ng-template #defaultLabel>
          <span>Verification Code</span>
          <span class="required">*</span>
          </ng-template>
        </div>
        
        <div class="otp-input-container">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" [(ngModel)]="otp[0]" (input)="onOtpChange(0, $event)" (keypress)="onlyNumeric($event)" #otpFirst>
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" [(ngModel)]="otp[1]" (input)="onOtpChange(1, $event)" (keypress)="onlyNumeric($event)">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" [(ngModel)]="otp[2]" (input)="onOtpChange(2, $event)" (keypress)="onlyNumeric($event)">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" [(ngModel)]="otp[3]" (input)="onOtpChange(3, $event)" (keypress)="onlyNumeric($event)">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" [(ngModel)]="otp[4]" (input)="onOtpChange(4, $event)" (keypress)="onlyNumeric($event)">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" [(ngModel)]="otp[5]" (input)="onOtpChange(5, $event)" (keypress)="onlyNumeric($event)">
        </div>
        
        <div class="timer-section">
  <button
    class="resend-btn"
    (click)="resendOtp()"
    [disabled]="timerActive || isResending || isBlocked">
    Resend Code
  </button>
  <div *ngIf="timerActive" class="timer timer-warning">
    {{ timerDisplay }}
  </div>
  <div *ngIf="isBlocked" class="lockout-message">
    Resend Code is disabled due to too many failed attempts. Please try again after 15 minutes.
  </div>
</div>

        <div *ngIf="errorMessage" class="error-message1">
          {{ errorMessage }}
        </div>
        
        <div class="action-buttons">
          <button class="verify-btn" (click)="verifyOtp()">Verify Code</button>
          <!-- <button >Cancel</button> -->
        </div>
      </div>
    </div>
  </div>
</div>